import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  InputGroup,
  Switch,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { createViewModel } from "mobx-utils";
import * as React from "react";
import { MvaStoreRS } from "../../stores/mvas/MvaStoreRS";
import { MDBCol, MDBRow } from "mdbreact";
import { toast } from "react-toastify";
import MomentLocaleUtils from "react-day-picker/moment";
import { DateInput } from "@blueprintjs/datetime";
import * as moment from "moment";
import { format_value_mva, getMomentFormatter } from "../../utils";
import { IMvaRS } from "../../model";
const InputMask = require("react-input-mask");

interface MvaRsDialogDuplicarProps {
  mva: IMvaRS;
  onClose: () => void;
}

interface MvaRsDialogDuplicarState {
}

@observer
export class MvaRsDialogDuplicar
  extends React.Component<MvaRsDialogDuplicarProps, MvaRsDialogDuplicarState> {
  obs = observable({
    mva: {} as IMvaRS
  })

  async componentDidMount() {

    this.obs.mva = { ...this.props.mva }

  }

  handleSaveDuplica = async (mva) => {

    mva.mva_positiva = format_value_mva(mva.mva_positiva)
    mva.mva_neutra = format_value_mva(mva.mva_neutra)
    mva.mva_negativa = format_value_mva(mva.mva_negativa)
    mva.mva_ajustada_4 = format_value_mva(mva.mva_ajustada_4)
    mva.mva_ajustada_7 = format_value_mva(mva.mva_ajustada_7)
    mva.mva_ajustada_12 = format_value_mva(mva.mva_ajustada_12)
    mva.mva_ajustada = format_value_mva(mva.mva_ajustada)
    mva.mva = format_value_mva(mva.mva)
    mva.aliquota_interna = format_value_mva(mva.aliquota_interna).replace(/\,/g, ".")

    delete mva._id
    delete mva.id

    let res = await MvaStoreRS.doSaveDuplicaMva(mva);

    if (res) {

      this.props.onClose()

    }

  };

  render() {

    if (!this.obs.mva) {
      return null;
    }

    return (
      <Dialog
        isOpen={true}
        onClose={this.props.onClose}
        style={{ width: 600, height: 400 }}
      >
        <div className={Classes.DIALOG_HEADER}>
          <h2 className="title-no-bottom">Duplicar MVA</h2>
        </div>

        <div className={Classes.DIALOG_BODY}>
          <MDBRow>
            <MDBCol>
              <FormGroup label="MVA Positiva">
                <InputGroup value={this.obs.mva.mva_positiva} onChange={(e) => this.obs.mva.mva_positiva = e.target.value} placeholder="Exemplo: 54,8950" />
              </FormGroup>
            </MDBCol>
            <MDBCol>
              <FormGroup label="MVA Neutra">
                <InputGroup value={this.obs.mva.mva_neutra} onChange={(e) => this.obs.mva.mva_neutra = e.target.value} placeholder="Exemplo: 54,8950" />
              </FormGroup>
            </MDBCol>
            <MDBCol>
              <FormGroup label="MVA Negativa">
                <InputGroup value={this.obs.mva.mva_negativa} onChange={(e) => this.obs.mva.mva_negativa = e.target.value} placeholder="Exemplo: 54,8950" />
              </FormGroup>
            </MDBCol>
          </MDBRow>

          <MDBRow>
            <MDBCol>
              <FormGroup label="MVA Ajustada 4%">
                <InputGroup value={this.obs.mva.mva_ajustada_4} onChange={(e) => this.obs.mva.mva_ajustada_4 = e.target.value} placeholder="Exemplo: 54,8950" />
              </FormGroup>
            </MDBCol>
            <MDBCol>
              <FormGroup label="MVA Ajustada 7%">
                <InputGroup value={this.obs.mva.mva_ajustada_7} onChange={(e) => this.obs.mva.mva_ajustada_7 = e.target.value} placeholder="Exemplo: 54,8950" />
              </FormGroup>
            </MDBCol>
            <MDBCol>
              <FormGroup label="MVA Ajustada 12%">
                <InputGroup value={this.obs.mva.mva_ajustada_12} onChange={(e) => this.obs.mva.mva_ajustada_12 = e.target.value} placeholder="Exemplo: 54,8950" />
              </FormGroup>
            </MDBCol>
          </MDBRow>

          <MDBRow>
            <MDBCol>
              <FormGroup label="MVA Ajustada">
                <InputGroup value={this.obs.mva.mva_ajustada} onChange={(e) => this.obs.mva.mva_ajustada = e.target.value} placeholder="Exemplo: 54,8950" />
              </FormGroup>
            </MDBCol>
            <MDBCol>
              <FormGroup label="MVA">
                <InputGroup value={this.obs.mva.mva} onChange={(e) => this.obs.mva.mva = e.target.value} placeholder="Exemplo: 54,8950" />
              </FormGroup>
            </MDBCol>
            <MDBCol>
              <FormGroup label="Aliquota Interna">
                <InputGroup value={this.obs.mva.aliquota_interna} onChange={(e) => this.obs.mva.aliquota_interna = e.target.value} placeholder="Exemplo: 54,8950" />
              </FormGroup>
            </MDBCol>
          </MDBRow>

        </div>

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={this.props.onClose} />
            <Button text="Duplicar" intent="primary" onClick={() => this.handleSaveDuplica(this.obs.mva)} />
          </div>
        </div>
      </Dialog>
    );
  }
}
